import { create } from 'zustand';
import { apiClient } from '../api';
import type { ApiResponse } from '../types';

interface PublicConfigPayload {
  gmailMailboxAddress: string;
}

interface PublicConfigState {
  gmailMailboxAddress: string | null;
  isLoaded: boolean;
  isLoading: boolean;
  fetch: () => Promise<void>;
}

export const usePublicConfigStore = create<PublicConfigState>((set, get) => ({
  gmailMailboxAddress: null,
  isLoaded: false,
  isLoading: false,
  fetch: async () => {
    if (get().isLoaded || get().isLoading) return;
    set({ isLoading: true });
    try {
      // `background`: fetched on app load, never user-initiated — must not toast (86d3va61r).
      const { data } = await apiClient.get<ApiResponse<PublicConfigPayload>>(
        '/configuration/public',
        { background: true },
      );
      if (data.success && data.data) {
        set({
          gmailMailboxAddress: data.data.gmailMailboxAddress,
          isLoaded: true,
        });
      }
    } catch {
      // Public-config failure is non-fatal — the AutoDraft review card falls back to
      // a Gmail link without authuser= (still works, just opens default account).
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const useGmailMailboxAddress = (): string | null =>
  usePublicConfigStore((s) => s.gmailMailboxAddress);
